import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { ArrowUpload24Regular } from '@fluentui/react-icons';
import { useFileDropTarget } from './useFileDropTarget';
import { useFileDropZoneStyles } from './FileDropZone.Styles';

export interface FileDropZoneProps {
  /** When false the zone is inert and children render as usual */
  enabled: boolean;
  /** Text shown over the content while files are dragged over it (already translated) */
  overlayText: string;
  onFilesDropped: (files: File[]) => void;
  className?: string;
  children: React.ReactNode;
}

/** Wraps a list/page so files dropped from the OS open the upload drawer. */
export const FileDropZone = ({ enabled, overlayText, onFilesDropped, className, children }: FileDropZoneProps) => {
  const styles = useFileDropZoneStyles();
  const { isDraggingFiles, dropTargetProps } = useFileDropTarget({ enabled, onFilesDropped });

  return (
    <div className={mergeClasses(styles.root, className)} data-testid="file-drop-zone" {...dropTargetProps}>
      {children}
      {enabled && isDraggingFiles && (
        <div className={styles.overlay} data-testid="file-drop-zone-overlay" aria-live="polite">
          <ArrowUpload24Regular className={styles.icon} />
          <span>{overlayText}</span>
        </div>
      )}
    </div>
  );
};

export default FileDropZone;
